var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.649 5.738a.625.625 0 0 1-.204.86 4.87 4.87 0 0 0-2.32 4.152A4.87 4.87 0 0 0 10 15.625a4.87 4.87 0 0 0 4.875-4.875 4.87 4.87 0 0 0-2.32-4.151.625.625 0 0 1 .656-1.064 6.12 6.12 0 0 1 2.914 5.215A6.12 6.12 0 0 1 10 16.875a6.12 6.12 0 0 1-6.125-6.125c0-2.21 1.17-4.14 2.913-5.215a.625.625 0 0 1 .86.203",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3.125c.345 0 .625.28.625.625v3.667a.625.625 0 1 1-1.25 0V3.75c0-.345.28-.625.625-.625",
    clipRule: "evenodd"
  })));
};
export default SvgLogOut;